/**
 * EmbedLoader — Minimal loading screen for ?mode=embed
 *
 * Black background with a centered rectangular progress bar.
 * No logo, no text, no branding — just functional loading feedback.
 */
import { useAppStore } from '../../store/app.store';

export function EmbedLoader() {
  const progress = useAppStore((s) => s.loadingProgress);
  const transparentBg = useAppStore((s) => s.transparentBg);

  return (
    <div
      className={`h-full w-full flex items-center justify-center${transparentBg ? '' : ' bg-black'}`}
    >
      <div className="w-48 h-1 overflow-hidden" style={{ backgroundColor: '#101319' }}>
        <div
          className="h-full"
          style={{
            width: `${progress}%`,
            backgroundColor: '#657081',
            transition: 'width 600ms ease-out',
          }}
        />
      </div>
    </div>
  );
}
